import { useOne as useRefineOne, useResourceParams } from "@refinedev/core";
import { useResourceContext } from "@/layouts/ResourceContext";

export const useResourceOne = (props = {}) => {
  const { resource: resourceFromProps, id: idFromProps, skip } = props;
  const { resource: resourceDef, id: idFromParams, action } = useResourceParams();
  const resource = resourceFromProps ?? resourceDef.name;
  const id = idFromProps ?? idFromParams;
  const { tenantName } = useResourceContext();
  const meta = {}
  if(tenantName) {
    meta.tenantName = tenantName;
  }

  const result = useRefineOne(!skip && { ...props, resource, id , meta});
  return result;
};

export const useOne = useResourceOne;